import React, { useState, useEffect } from 'react';
import ClassTableComp from './ClassTableComp';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import StudentTable from './StudentTableComp';
import StaticNav from '../common/StaticNav';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BulkStudentComp from './BulkStudentComp';
import ImportUsersComp from './ImportUsersComp';
import BreadCrumbs from './BreadCrumbs';
import AddUserComp from './AddUserComp';
import LinkStudentsComp from './LinkStudentsComp';
import TeacherProfile from './TeacherProfile';
import { Redirect} from 'react-router-dom';
import { request, deleteThis, internalUpdate } from '../../redux/actions/genericAction';
import { toArray } from '../../Utils';

const UserPage = ({isAdmin, classesData, database, request, internalUpdate, deleteThis}) => {
  const [hasDatabaseData, sethasDatabaseData] = useState(true);
  const [showBulkStudentComp, setShowBulkStudentComp] = useState(false);
  const [showImportUsersComp, setShowImportUsersComp] = useState(false);
  const [showClassTableComp, setShowClassTableComp] = useState(isAdmin?true:false);
  const [showStudentTableComp, setShowStudentTableComp] = useState({display:true, classInfo:{ClassID:'', Classname:''}});
  const [showAddUserComp, setShowAddUserComp] = useState(false);
  const [showLinkStudentsComp, setShowLinkStudentsComp] = useState(false);
  const [showTeacherProfileComp, setShowTeacherProfileComp] = useState(false);
  const [breadCrumbs, setBreadCrumbs] = useState([]);
  const [userType, setUserType] = useState(isAdmin?'Class':'Student');
  const [pageType, setPageType] = useState(isAdmin?'Class':'Student');
  const [classEditsForSave, setClassEditsForSave] = useState({});
  const [studentEditsForSave, setStudentEditsForSave] = useState({});

  useEffect(() => {
    if(!database['getCustomer'])
      return sethasDatabaseData(false);

      if(database['getStudentsForClass'] && database['getStudentsForClass'].data && database['getStudentsForClass'].isLoaded) {
        if(toArray(database['getStudentsForClass'].data).length === 0 && showStudentTableComp.display===true){
          console.log('showStudentTableComp.display',showStudentTableComp.display);
          setShowStudentTableComp({...showStudentTableComp, display:false});
        }
        if(toArray(database['getStudentsForClass'].data).length > 0 // only show students in the show students window
          && showStudentTableComp.display===false 
          && showClassTableComp===false
          && showAddUserComp === false
          && showBulkStudentComp === false
          && showImportUsersComp === false
          && showLinkStudentsComp === false
          && showTeacherProfileComp === false
        ){
          setShowStudentTableComp({...showStudentTableComp, display:true});
        }
      }
  });

  useEffect(() => {
    if(!database['getAllClasses']) return;

    if(isAdmin){
      setShowStudentTableComp({...showStudentTableComp, display:false});
      pageState.setUserType('Class');
    }
    else{
      let theClass = toArray(database['getAllClasses'].data).find(e=>e.ClassID===database['teacherID']);
      setShowStudentTableComp({...showStudentTableComp, classInfo:{ClassID:theClass.ClassID, Classname:theClass.Classname}, display:true});
      pageState.setUserType('Student');
    }

  }, [database['getAllClasses']]);

  const pageState = {
    breadCrumbs, setBreadCrumbs, isAdmin,
    userType, setUserType,
    pageType, setPageType,
    classEditsForSave, setClassEditsForSave,
    studentEditsForSave, setStudentEditsForSave,

    classesData,
    database, request, deleteThis, internalUpdate,
    
    showBulkStudentComp, 
    showImportUsersComp, 
    showClassTableComp, 
    showStudentTableComp, 
    showAddUserComp, 
    showLinkStudentsComp, 
    showTeacherProfileComp,
    setShowStudentTableComp,

    closeAll:()=>{
      setShowBulkStudentComp(false); 
      setShowImportUsersComp(false); 
      setShowClassTableComp(false);
      setShowStudentTableComp({...showStudentTableComp, display:false}); 
      setShowAddUserComp(false); 
      setShowLinkStudentsComp(false); 
      setShowTeacherProfileComp(false);
    },

    showClassScreen: ()=>{
      setBreadCrumbs([]);
      setUserType('Class');
      pageState.closeAll();
      setShowClassTableComp(true);
    },

    showStudentScreen: (classInfo)=>{
      (isAdmin) && setBreadCrumbs([{text:'Classes', callback: pageState.showClassScreen, isActive: false},{text:'Students', isActive: true}]);
      (!isAdmin) && setBreadCrumbs([]);
      pageState.closeAll();
      showStudentTableComp.display=true;
      setShowStudentTableComp({...showStudentTableComp, ...classInfo});
    },

    cbShowAddUserScreen: (type) => () => {pageState.showAddUserScreen(type);},
    showAddUserScreen: (type) =>{
        setPageType(type);
        (pageState.userType==='Class' && type==='Class') &&
          setBreadCrumbs([
            {text:'Classes', callback: pageState.showClassScreen, isActive: false},
            {text:'Create Class', isActive: true}
          ]);
        (pageState.userType==='Class' && type==='Student') &&
          setBreadCrumbs([
            {text:'Classes', callback: pageState.showClassScreen, isActive: false},
            {text:'Students', callback: pageState.showStudentScreen, isActive: false},
            {text:'Create Student', isActive: true}
          ]);
        (pageState.userType==='Student') &&
          setBreadCrumbs([
            {text:'Students', callback: pageState.showStudentScreen, isActive: false},
            {text:'Create Student', isActive: true}
          ]);

        pageState.closeAll();
        setShowAddUserComp(true);
    },

    closeAddUserScreen: (type) =>{
      (type === 'Class') ? pageState.showClassScreen() : pageState.showStudentScreen();
    },

    showImportUsersScreen: () =>{
      setBreadCrumbs([
        {text:'Classes', callback: pageState.showClassScreen, isActive: false},
        {text:'Create Class', callback: pageState.cbShowAddUserScreen('Class'), isActive: false},
        {text:'Import', isActive: true}
      ]);

      pageState.closeAll();
      setShowImportUsersComp(true); 
    },

    showBulkStudentScreen: () =>{
      isAdmin &&
      setBreadCrumbs([
        {text:'Classes', callback: pageState.showClassScreen, isActive: false},
        {text:'Students', callback: pageState.showStudentScreen, isActive: false},
        {text:'Create Students', callback: pageState.cbShowAddUserScreen('Student'), isActive: false},
        {text:'By list', isActive: true}
      ]);
      
      !isAdmin &&
      setBreadCrumbs([
        {text:'Students', callback: pageState.showStudentScreen, isActive: false},
        {text:'Create Students', callback: pageState.cbShowAddUserScreen('Student'), isActive: false},
        {text:'By list', isActive: true}
      ]);

      pageState.closeAll();
      setShowBulkStudentComp(true); 
    },

    showLinkStudentsScreen: () =>{

      isAdmin &&
      setBreadCrumbs([
        {text:'Classes', callback: pageState.showClassScreen, isActive: false},
        {text:'Students', callback: pageState.showStudentScreen, isActive: false},
        {text:'Link Students', isActive: true}
      ]);
      
      !isAdmin &&
      setBreadCrumbs([
        {text:'Students', callback: pageState.showStudentScreen, isActive: false},
        {text:'Link Students', isActive: true}
      ]);

      pageState.closeAll();
      setShowLinkStudentsComp(true); 
    },

    showProfileScreen: ()=>{

      setBreadCrumbs([
        {text:'Classes', callback: pageState.showClassScreen, isActive: false},
        {text:'Students', callback: pageState.showStudentScreen, isActive: false},
        {text:'Edit Teacher', isActive: true}
      ]);

      pageState.closeAll();
      setShowTeacherProfileComp(true); 
    },

  };
  
  if (!hasDatabaseData) {
    return <Redirect to='/' />;
  }

  return(
  <div>
      <br/>
      <StaticNav currentTopic={'Users'}/>  

      {!isAdmin && <>
        {database['getStudentsForClass'] && database['getStudentsForClass'].isLoaded &&
        toArray(database['getStudentsForClass'].data).length > 0 &&
          <BreadCrumbs pageState={pageState}/>}
        <AddUserComp pageState={pageState} type='Student'/>
        <BulkStudentComp pageState={pageState}/> 
        <StudentTable pageState={pageState}/>
        <LinkStudentsComp pageState={pageState} /> 

        {database['getStudentsForClass'].isLoaded && toArray(database['getStudentsForClass'].data).length == 0 
          && sessionStorage.getItem("LTIMode") && sessionStorage.getItem("LTIMode")=="Clever_Library" && <>
          This class has no students.  Please add students to this class by clicking the link below.<br/>
          <a href={`https://online.essentialskills.com/sso/clever/library/fullteacher/subscription.php?ID=${database['getCustomer'].data['URL_NUM']}&token=${sessionStorage.getItem('token')}&userID=${sessionStorage.getItem('userID')}&teacherID=${sessionStorage.getItem('teacherID')}`} >
            Add Clever Library Students
          </a>

        </>}

      </>}
      {isAdmin && <>
        {database['getAllClasses'] && database['getAllClasses'].isLoaded &&
        toArray(database['getAllClasses'].data).length > 0 &&
          <BreadCrumbs pageState={pageState}/>}        
        {(pageType==='Student' && (showAddUserComp || showBulkStudentComp)) &&
        // eslint-disable-next-line react/no-unescaped-entities
        <Row><Col xs='12'> <h2> {showStudentTableComp.classInfo.Classname} Class </h2></Col> </Row>}
        <Row>          
          <ImportUsersComp pageState={pageState}/>
          <Col xs='12'><TeacherProfile pageState={{innerState:pageState, database, request}}/></Col> 
          <Col xs='12'><AddUserComp pageState={pageState} type='Class'/></Col> 
          <Col xs='12'><ClassTableComp pageState={pageState}/></Col>
          <Col xs='12'><BulkStudentComp pageState={pageState}/></Col>
          <Col xs='12'><StudentTable pageState={pageState}/></Col>
          <Col xs='12'><LinkStudentsComp pageState={pageState}/></Col>
        </Row>
        </>
      }
  </div>);
};

UserPage.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
  let classesData = (state.genericReducer['getAllClasses']) ? state.genericReducer['getAllClasses'].data: undefined;
  return {
      isAdmin: (state.dashboardReducer.login === 'Admin'),
      database: state.genericReducer,
      classesData
  };
};

export default connect(mapStateToProps, {request, deleteThis, internalUpdate})(UserPage);